import * as React from 'react';
import { connect } from 'react-redux';

import { selectSpaceInfo } from '../selectors/ContentSelectors';
import { AppState } from '../state/AppState';
import { SpaceInfo } from '../state/SpaceInfo';
import { MapStateToProps } from '../utils/ConnectUtils';
import { SkipBar } from './SkipBar';

export interface SkipBarProviderStateProps {
  readonly spaceInfo: SpaceInfo;
}

export type SkipBarProviderProps = SkipBarProviderStateProps;

export const SkipBarProvider: React.FunctionComponent<SkipBarProviderProps> = (props: SkipBarProviderProps) => {
  if (props.spaceInfo.spaceType === 'view') {
    const iframeSelector = '#viz iframe';
    const vizIsVisible = $(iframeSelector).length > 0;
    return <SkipBar iframeSelector={vizIsVisible ? iframeSelector : null} contentSelector={'#main-content'}/>;
  }

  return null;
};

const mapStateToProps: MapStateToProps<SkipBarProviderStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
});

export const ConnectedSkipBarProvider: React.ComponentClass<{}> = connect(mapStateToProps, null)(SkipBarProvider);
